import { TemplatePage } from './types';

const healthcarePage: TemplatePage = {
  header: {
    color: '#FCDADB',
    icon: 'images/video-templates/healtcare-pharma.jpg',
    title: 'Healthcare & Pharma Video Templates Collection',
    title_meta: '50+ Free and Customizable Healthcare Video Templates',
    description_meta:
      'Increase awareness of your health & pharma business with videos. Use Wave.video’s 50+ healthcare video templates ' +
      'to help your improve the physical and mental wellbeing. ',
    description:
      'These video templates are designed to help healthcare professionals and pharma businesses to address health ' +
      'concerns, promote their solutions and educate the audience on how to maintain physical and mental wellbeing.'
  },
  footer: {
    category: 'Healthcare & Pharma',
    description:
      'With a wide range of Wave.video’s customizable templates, it’s easy to create appealing multi-format videos ' +
      'on any topic. Make videos to share your expertise, educate about the latest trends and pique your audience’s interest.'
  },
  content: [
    {
      type: 'templates',
      title: 'healthcare',
      search: { category: '/Industries/Healthcare' }
    },
    {
      type: 'stocks',
      title: 'healthcare ',
      search: { name: 'healthcare' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default healthcarePage;
